export default {
  CurrencyConversionRateAddEdit: 'currencyConversionRateAddEdit',
  CurrencyConversionRateRemove: 'currencyConversionRateRemove',
};
